module.exports = __webpack_public_path__ + "static/img/T2511271.28e7f37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/T2511271.png
// module id = Z+s2
// module chunks = 5